import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { Empty_Kartable_Order_Interface, Kartable_Order_Interface } from 'src/app/Interface/Kartable_Order_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { KartableService } from 'src/app/Service/Kartable/Kartable.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-KartableCertificate',
  templateUrl: './KartableCertificate.component.html',
  styleUrls: ['./KartableCertificate.component.scss']
})
export class KartableCertificateComponent implements OnInit {
  PersianToDayDate: String = ""
  BaseUrl = environment.BaseUrl
  LabUrl = environment.LabUrl


  Filter_Customer_Order: string = ""
  Filter_RecieveCode_Order: string = ""
  Filter_Certificate_User: string = ""

  Filter_Code2_Order: string = ""
  Filter_Devicename_Order: string = ""
  Filter_Expert_Name_Order: string = ""
  
  Filter_Device_Code: string = ""
  Filter_Device_Serial: string = ""
  
  SubmitPeriodDate: string = '0'

  page_Kartable: 0


  constructor(
    private Kartable_Service: KartableService,
    private Alertify_Service: AlertifyService,
    private Nav_Service: NavService,
    private modalService: BsModalService
  ) { }


  Change_Filter_Order() {
    this.page_Kartable = 0
  }


  ngOnInit() {
    this.Nav_Service.CheckValidPage(2188).subscribe(
      data => {

      }
      , error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }


  Procssing_Kartable: boolean = false
  DataList_Kartable: Array<Kartable_Order_Interface> = []
  DataList_Kartable_Selected: Kartable_Order_Interface = Empty_Kartable_Order_Interface()
  Data_Seleted_Delete_Status: number = 0
  OperationDsc: string = ''
  modalRef_Delete: any;

  ReadData_Kartable(StartSearchDate, EndSearchDate) {
    this.Procssing_Kartable = true
    this.Kartable_Service.GetCertificate(this.Filter_Customer_Order,
      this.Filter_Expert_Name_Order,
      this.Filter_RecieveCode_Order,
      this.Filter_Code2_Order,
      this.Filter_Devicename_Order,
      Number(this.SubmitPeriodDate),
      StartSearchDate,
      EndSearchDate).subscribe(
        data => {
          this.DataList_Kartable = data

          this.Procssing_Kartable = false
        }, error => {
          // AuthInterceptor owns authentication; feature errors must preserve credentials.

        }
      )
  }

  SetCalibrationDetailVisible(item: Kartable_Order_Interface) {
    item.Processing = true

    this.Kartable_Service.SetCalibrationDetailVisible(item.id2).subscribe(
      data => {
        item.expert_submit_date_visible = true
        item.Processing = false
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }

  openModal(template: TemplateRef<any>, Record: Kartable_Order_Interface, Status: number) {
    this.DataList_Kartable_Selected = Record
    this.OperationDsc = ""
    this.Data_Seleted_Delete_Status = Status
    this.modalRef_Delete = this.modalService.show(template);
  }



  //#region Device Behfa

  DataList_Kartable_Selected_DeviceBehfa: Kartable_Order_Interface = Empty_Kartable_Order_Interface()

  OnSet_Calibration_DeviceBehfa(item: Kartable_Order_Interface) {
    this.DataList_Kartable_Selected_DeviceBehfa = item
  }

  OnSet_Back_Calibration_DeviceBehfa() {
    this.DataList_Kartable_Selected_DeviceBehfa = Empty_Kartable_Order_Interface()
  }

  //#endregion


  //#region Controller
  Selected_DataList_Calibration: Kartable_Order_Interface = Empty_Kartable_Order_Interface()
  Controller_Data_List: Array<General_Interface> = []
  modalRef_Controller: any;

  openModal_Controller(template: TemplateRef<any>, item: Kartable_Order_Interface) {
    this.modalRef_Controller = this.modalService.show(template);
    this.Selected_DataList_Calibration = item
    this.Controller_Data_List = item.controller
  }

  //#endregion

  //#region Calibration Status
  Certificate_Dsc: string = ''
  modalRef_Certificate: any;
  Selected_DataList_Certificate: Kartable_Order_Interface = Empty_Kartable_Order_Interface();
  openModal_Certificate(template: TemplateRef<any>, item: Kartable_Order_Interface) {
    this.modalRef_Certificate = this.modalService.show(template);
    this.Selected_DataList_Certificate = item
    this.Certificate_Dsc=''
  }

  SubmitCertificate() {
    this.Procssing_Kartable = true
    this.modalRef_Certificate.hide()
    this.Kartable_Service.SubmitCertificate(this.Selected_DataList_Certificate.calibration_detail_id,this.Certificate_Dsc).subscribe(
      data => {
        this.Procssing_Kartable = false

        if (data.id == -1) {
          this.Alertify_Service.ErrorMessage("درخواست بازیابی برای این گواهی نامه در سامانه وجود دارد")
        }
        else if (data.id == -2) {
          this.Alertify_Service.ErrorMessage("گردش کار فعالی برایبازیابی گواهی نامه انتخاب نشده است")
        }
        else if (data.id == -3) {
          this.Alertify_Service.ErrorMessage("خطا سیستمی")
        }
        else if (data.id == -4) {
          this.Alertify_Service.ErrorMessage("در چارت سازمانی بدون سمت هستید")
        }
        else {
          this.Alertify_Service.SuccessMessage("درخواست ثبت شد")
        }
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )


  }

  //#endregion


}
